module.exports = __webpack_public_path__ + "img/SearchOnlineCarsLogoWhiteOutlines.a5d876a2.png";